export default {
	es: {

		enlaces : {
			home : "/",
			contacto : "/contacto",
			trabaja_con_nosotros: "/trabaja-con-nosotros",
			politica_privacidad : "/politica-de-privacidad",
			politica_cookies : "/politica-de-cookies",
			condiciones_contrato : "/condiciones-del-contrato",
			aviso_legal : "/aviso-legal",
			terminos_y_condiciones : "/terminos-y-condiciones",

			firma_contrato : "/firma-contrato",
			asi_somos : "/asi-somos",
			que_ofrecemos : "/que-ofrecemos",
			ofrecemosMuchoMas : "/otros-servicios",
			tarifas : "/tarifas",
			tarifas_luz : "/tarifas/luz",
			tarifas_gas : "/tarifas/gas",
			tarifas_luzgas : "/tarifas/luz-y-gas",
			blog : "/blog",
			inergizate : "/inergizate",
			franquicia : "/franquicia",
			simulador : "/simulador",
			preguntas_frecuentes : "/preguntas-frecuentes",
			bases_legales : "/bases-legales",
			promociones : "/promociones",
			okfirma : '/contrato-firmado',
			contratoSolicitado : '/contrato-solicitado',
			empresas : '/empresas',
			teayudamos : '/empresas/te-ayudamos',
			luzempresas : '/empresas/tarifas/luz',
			autoconsumo : "/autoconsumo",
			autoconsumo_tarifas : "/autoconsumo/tarifas",
			autoconsumo_iner : "/autoconsumo/autoconsumo-con-iner",
			autoconsumo_ayudamos : "/autoconsumo/te-ayudamos",
			landing_autoconsumo : "/autoconsumo/informacion",
			calculo_autoconsumo : "/autoconsumo/calculadora",
			condiciones_autoconsumo : '/autoconsumo/condiciones-de-pago',
			mapa_autoconsumo : '/autoconsumo/mapa-tejado'

		},
		seo : {
			home : {
				title : "Somos Iner Energía - Inergiza tu tejado",
				description : "Iner Energía, la energía con personalidad propia que ofrece placas solares y luz siempre con el mejor precio."
			},
			contacto : {
				title : "Contacta con Iner Energía",
				description : "¡Escríbenos o llámanos! Nuestro equipo de atención al cliente estará encantado de ayudarte"
			},
			trabaja_con_nosotros: {
				title : "Iner - Trabaja con nosotros",
				description : "trabaja_con_nosotro"
			},
			politica_privacidad : {
				title : "Política de privacidad Iner Energía",
				description : "En Iner Energía te garantizamos la seguridad de tus datos"
			},
			politica_cookies : {
				title : "Política de cookies Iner Energía",
				description : "Todos los detalles acerca de nuestra política de cookies"
			},
			condiciones_contrato : {
				title : "Condiciones del contrato Iner Energía",
				description : "Conoce nuestras condiciones del contrato"
			},
			aviso_legal : {
				title : "Aviso legal Iner Energía",
				description : "Todos los detalles acerca de nuestro aviso legal"
			},
			terminos_y_condiciones : {
				title : "Términos y condiciones Iner Energía",
				description : "Todos los detalles acerca de nuestros términos y condiciones"
			},
			firma_contrato : {
				title : "Iner - Firma del contrato",
				description : "firma_contrato"
			},
			asi_somos : {
				title : "Iner Energía - La Energética con Personalidad Propia",
				description : "Iner energía la compañía cercana, clara, libre y práctica que se suma a las energías renovables."
			},
			que_ofrecemos : {
				title : "Iner Energía - Descubre Todos Nuestros Servicios",
				description : "En Iner Energía te ofrecemos un amplio abanico de servicios adaptados a tu vivienda y cartera. Autoconsumo, luz, gas, mantenimiento, puntos de recarga para coche eléctrico y más."
			},
			ofrecemosMuchoMas : {
				title : "Otros servicios Iner Energía",
				description : "Descubre nuestros servicios complementarios a tu tarifa de luz y gas"
			},
			tarifas : {
				title : "Iner - Tarifas",
				description : "tarifas"
			},
			tarifas_luz : {
				title : "Iner Energía - Tarifas de Luz a Precio de Coste",
				description : "Descubre nuestras tarifas de luz a precio de coste desde tan solo 3,65€ al mes cuota fija mensual. ¡Somos los más baratos del mercado!"
			},
			tarifas_gas : {
				title : "Iner Energía - Descubre Nuestras Tarifas de Gas a Precio Fijo",
				description : "Elige la tarifa de gas que mejor se adapte a ti. Gas a precio fijo desde tan solo 3,65€ al mes cuota fija mensual. ¡Somos la compañía de gas más económica del mercado!"
			},
			tarifas_luzgas : {
				title : "Iner Energía - Tarifas de Luz y Gas al Mejor Precio ",
				description : "Contrata luz y gas con Iner energía y ahorra en el coste de tu factura mensual. Tu tarifa de luz y gas desde 6,00€ al mes cuota fija mensual. ¡La cuota de gestión más competitiva del mercado!"
			},
			blog : {
				title : "Blog Iner Energía",
				description: "Queremos informarte de todas nuestras novedades y ofrecerte información de interés, trucos, consejos y mucho más a través de nuestro blog."
			},
			inergizate : {
				title : "Iner energía - Contrata Luz o Gas a Precios imbatibles",
				description : "En Iner Energía te ofrecemos un proceso de contratación, rápido, gratuito y sin papeleos en tan solo 2 minutos. Contrata nuestros servicios de luz o gas y comienza a ahorrar desde este mismo momento."
			},
			franquicia : {
				title : "franquicia",
				description : "franquicia"
			},
			simulador : {
				title : "Simulador de consumo de energía",
				description : "Calcula lo que te costaría la luz con Iner gracias a nuestro simulador"
			},
			preguntas_frecuentes : {
				title : "Todo sobre Iner Energía",
				description : "Te contamos todo lo que necesites saber acerca de nosotros: ¡no te quedes con dudas!"
			},
			promociones : {
				title : "Promociones Iner Energía",
				description : "Descubre todas nuestras promociones y ofertas en luz y gas"
			},
			okfirma : {
				title : "¡Ya eres un iner!",
				description : ""
			},
			contratoSolicitado : {
				title : "Revisa tu bandeja de correo",
				description : ""
			},
			empresas : {
				title : "Iner energía - Servicios de Luz y Gas Para Empresas",
				description : "Somos la mejor opción para tu empresa. Sea cual sea su tamaño, potencia o consumo, te ofrecemos la mejor tarifa de luz o gas para tu negocio."
			},
			tarifasempresas : {
				title : "Iner energía - Servicios de Luz y Gas Para Empresas",
				description : "Elige la tarifa que mejor se adapte a tu empresa. Podrás disfrutar de precios imbatibles tanto si tu negocio es pequeño como si se trata de una gran empresa. Si lo deseas, disfruta también de nuestra tarifa tranquilidad, mismo precio, todo el año."
			},
			empresasayudamos : {
				title : "Iner Energía - ¿Necesitas Ayuda? ¡Te Ayudamos!",
				description : "Si quieres que uno de nuestros expertos te asesore para elegir la mejor tarifa para tu empresa, tan solo tienes que ponerte en contacto con nosotros a través de nuestro formulario."
			},
			autoconsumo : {
				title : "Iner Energía Autoconsumo - Instalación de Placas Solares",
				description : "Súmate al autoconsumo con Iner Energía. Disfruta de la energía que tu mismo produces al mejor precio."
			},
			autoconsumo_iner : {
				title : "Ahorra en tu Factura de la Luz con Iner Energía, Especializados en Autoconsumo",
				description : "Comienza a ahorrar con el Autoconsumo de Iner Energía. Instalación de Placas Solares en tu tejado desde 3.500€. Te compramos el excedente."
			},
			autoconsumo_tarifas : {
				title : "Iner Energía Autoconsumo - Tarifas de Autoconsumo Adaptadas a tu Hogar o Empresa",
				description : "Descubre nuestras tarifas de autoconsumo para particulares y empresas. Somos los más económicos del mercado y, además, te compramos el excedente cuando lo que produzcas sea mayor de lo que consumes."
			},
			autoconsumo_ayudamos : {
				title : "Iner Energía autoconsumo - Contacta con Nuestros Expertos en Energías Renovables",
				description : "Disfruta de un estudio personalizado de la mano de nuestros asesores para tu hogar o empresa. 100% gratuito. Energía renovable."
			},
			calculo_autoconsumo : {
				title : "Iner Energía Autoconsumo - Calcula tu Ahorro con Nuestro Simulador",
				description : "Calcula cuál será tu ahorro si te pasas al autoconsumo con Iner Energía. Somos los más competitivos del mercado. Autoconsumo al mejor precio."
			},
		},
		formulario : {
			nombre : "Nombre",
			nombre_apellidos : "Nombre y apellidos",
			apellidos : "Apellidos",
			email : "Email",
			mensaje : "Mensaje",
			fecha_nacimiento : "Fecha de nacimiento",
			dia : "Día",
			mes : "Mes",
			anyo : "Año",
			area_interes : "Área de su interés",
			trabaja_actualmente : "¿Trabaja actualmente?",
			si : "Si",
			no : "No",
			carta_presentacion : "Carta de presentacion",
			cuenta_bancaria : "Cuenta Bancaria",
			meses : {
				Enero : "Enero",
				Febrero : "Febrero",
				Marzo : "Marzo",
				Abril : "Abril",
				Mayo : "Mayo",
				Junio : "Junio",
				Julio : "Julio",
				Agosto : "Agosto",
				Septiembre : "Septiembre",
				Octubre : "Octubre",
				Noviembre : "Noviembre",
				Diciembre : "Diciembre"
			},
			mesesNumber : ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
			provincias : ['Alava','Albacete','Alicante','Almería','Asturias','Avila','Badajoz','Barcelona','Burgos','Cáceres',
			'Cádiz','Cantabria','Castellón','Ciudad Real','Córdoba','La Coruña','Cuenca','Gerona','Granada','Guadalajara',
			'Guipúzcoa','Huelva','Huesca','Islas Baleares','Jaén','León','Lérida','Lugo','Madrid','Málaga','Murcia','Navarra',
			'Orense','Palencia','Las Palmas','Pontevedra','La Rioja','Salamanca','Segovia','Sevilla','Soria','Tarragona',
			'Santa Cruz de Tenerife','Teruel','Toledo','Valencia','Valladolid','Vizcaya','Zamora','Zaragoza'],
			archivo_adjunto : "Adjuntar archivo",
			adjuntar_cv : "Adjuntar CV",
			introduce_mail : "Introduce tu email",
			pais : "País",
			telefono : "Teléfono",
			he_leido : "He leído y acepto la",
			y_acepto : "política de privacidad",
			enviar : "Enviar",
			enviado : "Enviado",
		},
		erroresCUPS : {
			"0" : "Error este CUPS no existe",
			"1" : "ERROR: Demasiada potencia contratada",
			"2" : "ERROR: Demasiado consumo",
			"3" : "ERROR: Tiene bono social",
			"4" : "ERROR: Campos vacios",
			"5" : "Por favor, corrija el campo DNI/CIF, está mal formado",
			"6" : "ERROR: DNI ERRONEO",
			"7" : "ERROR: DNI Erroneo",
			"8"  : "ERROR: Revisar la dirección",
			"9" : "ERROR: Cuenta bancaria erronea",
			"10" : "Error: Este CUPS ya tiene un contrato activo",
			"11" : "ERROR: Token caducado",
			"12" : "ERROR: Falta la firma",
			"13" : "ERROR: Error interno al procesar la firma",
			"14" : "ERROR: El contrato ya ha sido firmado ó no está habilitado para firmar",
			"15" : "ERROR: Ha ocurrido un error interno en la aplicación",
			"16" : "ERROR: El código es erroneo",
			"17" : "ERROR: El código ya está agotado", 
			"18" : "ERROR: El código ya no está disponible"
		}

	},
	en: {
		enlaces : {
			actualidad : '/news',
			sala_de_prensa : "/press-room",
			contacto : "/contact",
			trabaja_con_nosotros: "/work-with-us",
			politica_privacidad : "/privacy-policy",
			politica_cookies : "/cookies-policy",
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js